<template>
  <b-modal
    id="modal-export-transit-days"
    :title="$t('Exportar días adicionales temporales')"
    hide-footer
    modal-class="modal-background--multi-color"
    @close="onClose"
  >
    <form-render
      :form.sync="form"
      :fields="fields"
      :key="keyRenderExportTransitDays"
      containerButtonsClass="col-sm-12" ref="formRenderTransitDays"
    />
    <div class="d-flex justify-content-end w-100 pb-4">
      <b-button @click="ok" :variant="loading ? 'warning' : 'outline-warning'" :disabled="loading">
        <b-spinner v-show="loading" small></b-spinner> {{$t('Exportar')}}
      </b-button>
    </div>
    
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import CarriersService from '../carriers.service'

export default {
  name: 'modal-export-transit-days',
  props: ['clearBtn'],
  data() {
    return {      
      form: {},
      fields: [],
      keyRenderExportTransitDays: 0,
      vigencyRange: [
        {id: 1, text: 'Actual'},
        {id: 2, text: 'Programada'},
        {id: 3, text: 'Última Expirada'}
      ],
      loading: false,
      showCountries: ['CL', 'CO', 'PE', 'MX'],
      baseService : new CarriersService
    }
  },
  computed: {
    ...mapGetters({
      carriers: 'getCarriers'
    })
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.fields = [      
        { fieldType: 'FieldSelect', clearable: false, label: this.$t('Rangos de vigencia'), name: 'vigency_range', containerClass: 'col-12 container-info', validation: 'required', options: this.vigencyRange },
        { fieldType: 'FieldSelect', label: this.$t('Courier'), name: 'carrier', persistSearch: true, searchOnType: { fx: this.searchCourier, nChars: 3, debounce: 600 }, validation: 'required', containerClass: 'col-12 container-info', change: this.changeCarrier },
        {fieldType: 'FieldSelect', name: 'services', multiple: true, label: 'Servicios', dependency: 'carrier', containerClass: 'col-12 container-info'}
      ]
    },
    searchCourier(value) {
      const queryParams = {
        search_string: value,
        page: 1,
        limit: 10
      }
      return this.baseService.callService('getCarriers', queryParams)
        .then(resp => {
          return resp.data.map(carrier => ({...carrier, text: carrier.name}))
        })
        .catch((error) => {
          this.$bvToast.toast(error || 'Ha ocurrido un error al buscar el courier, por favor intentelo nuevamente', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        })
    },
    changeCarrier(_, value) {
      this.form.services = null
      if (!value) {
        this.setSelectOptions('services', [])
        return
      }
      this.setSelectOptions('services', value.services.map(serv => ({...serv, text: serv.name})))
    },
    setSelectOptions (name, options) {
      const index = this.fields.findIndex(el => el.name === name)
      if (index !== -1) {
        this.fields[index].options = options
        this.keyRenderExportTransitDays++
      }
    },
    async ok () {
      const form = await this.$refs.formRenderTransitDays.onlyCheckForm()
      if (!form) return
      this.loading = true
      const queryParams = {
        carrierCode: this.form.carrier.code,
        status: this.form.vigency_range.id
      }
      const headers = {
        email: this.$session.get('cas_user')?.email
      }
      if (!!this.form?.services && !!this.form?.services.length) queryParams.serviceCode = this.form.services.map(item => item.code).join(',')
      this.$store.dispatch('fetchService', {
        name: 'generateAdditionDaysExcel',
        queryParams,
        headers,
        onSuccess: (res) => {
          if (!!res?.fails.length) {
            if (!!res?.files_generated.length) {
              const files = res?.files_generated.length === 1 ? 'un archivo' : 'algunos archivos'
              this.$bvToast.toast('En breve recibirá un correo electrónico', {
                title: this.$t(`Se exportado con éxito ${files}`),
                variant: 'success',
                solid: true
              })
            }
            res.fails.forEach(fail => {
              this.$bvToast.toast(fail, {
                title: this.$t('Atención'),
                variant: 'warning',
                solid: true
              })
            })
            this.loading = false
            return
          }
          this.$newSuccess('¡La exportación se ha completado con éxito!', 'En breve recibirá un correo electrónico con el archivo adjunto.')
          this.onClose()
          this.$bvModal.hide('modal-export-transit-days')
        },
        hideAlert: true,
        onError: () => {
          this.loading = false
          this.$newError('¡Hubo un error durante la exportación!', 'Vuelva a intentarlo. Si el inconveniente persiste, contacta a nuestro equipo de Support para obtener más información.', 'xlarge')
        }
      })
    },
    onClose() {
      this.loading = false
      this.form = {}
      this.$emit('clearBtn')
    }
  }
}
</script>

<style lang="scss">
.option-dimension{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
}
.bg-white{
  background-color: white;
}
.inputIncreaseOrDiscount {
  width: 40%;
  > div {
    border-start-start-radius: 0 !important;
    border-end-start-radius: 0 !important;
    border-left: none !important;
    min-height: 100% !important;
  }
  > ul {
    top: auto;
    min-width: 100px;
  }
}
.inputApplyDiscountOrIncrease {
  width: 60%;
  border-start-end-radius: 0 !important;
  border-end-end-radius: 0 !important;
}
</style>
